export default __webpack_public_path__ + "static/media/statya71.a2df6728.pdf";